import { configurationsProd } from './configurations-prod';
import { configurationsDev } from './configurations-dev';
import { AppConfiguration } from './configuration.model';

const environment: string = process.env.NODE_ENV || 'development';
const configuration: AppConfiguration = environment === 'production' ? configurationsProd : configurationsDev;

export default configuration;